import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 bg-white border-t border-cream" data-id="element-56">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-4" data-id="element-57">
          <div className="flex items-center gap-6" data-id="element-58">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-lightText hover:text-darkText transition-colors underline underline-offset-2" data-id="element-59">
              Política de Privacidad
            </button>
            <span className="text-lightText/40" data-id="element-60">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-lightText hover:text-darkText transition-colors underline underline-offset-2" data-id="element-61">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-sm text-lightText" data-id="element-62">
            © {new Date().getFullYear()} InstaPrint AI. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" onClick={() => setActiveModal(null)} data-id="element-63">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-64">
            <div className="sticky top-0 bg-white border-b border-cream px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-65">
              <h2 className="text-xl font-heading font-bold text-darkText" data-id="element-66">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-cream transition-colors" data-id="element-67">
                <XIcon className="w-5 h-5 text-lightText" data-id="element-68" />
              </button>
            </div>

            <div className="px-6 py-6 text-lightText text-sm leading-relaxed space-y-4" data-id="element-69">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-70" /> : <TermsContent data-id="element-71" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-darkText font-bold text-base" data-id="element-72">
        Última actualización: Abril 2026
      </p>

      <p data-id="element-73">
        En InstaPrint AI, nos tomamos muy en serio la privacidad de nuestros
        usuarios. Esta política describe cómo recopilamos, usamos y protegemos
        tu información personal.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-74">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-75">
        Recopilamos la información que nos proporcionas directamente al realizar
        una compra, incluyendo tu nombre, dirección de correo electrónico y
        datos de pago. Los datos de pago son procesados de forma segura por
        nuestro proveedor de pagos y no se almacenan en nuestros servidores.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-76">2. Uso de la Información</h3>
      <p data-id="element-77">Utilizamos tu información para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-78">
        <li data-id="element-79">Procesar tu compra y entregarte el producto digital.</li>
        <li data-id="element-80">Enviarte actualizaciones importantes sobre tu compra.</li>
        <li data-id="element-81">Mejorar nuestros productos y servicios.</li>
      </ul>

      <h3 className="text-darkText font-bold mt-4" data-id="element-82">3. Protección de Datos</h3>
      <p data-id="element-83">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-84">4. Cookies</h3>
      <p data-id="element-85">
        Nuestro sitio web puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-86">5. Tus Derechos</h3>
      <p data-id="element-87">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. También puedes solicitar la portabilidad de tus
        datos.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-88">
        6. Cambios en esta Política
      </h3>
      <p data-id="element-89">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Te notificaremos sobre cambios significativos a
        través del correo electrónico asociado a tu compra.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-darkText font-bold text-base" data-id="element-90">
        Última actualización: Abril 2026
      </p>

      <p data-id="element-91">
        Al adquirir InstaPrint AI, aceptas los siguientes términos y
        condiciones. Por favor, léelos cuidadosamente antes de realizar tu
        compra.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-92">1. Producto Digital</h3>
      <p data-id="element-93">
        InstaPrint AI es un producto digital que incluye guías, plantillas y
        recursos educativos. El acceso se otorga de forma inmediata tras la
        confirmación del pago.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-94">2. Licencia de Uso</h3>
      <p data-id="element-95">
        Al comprar, recibes una licencia personal e intransferible para usar el
        contenido del producto. No está permitido redistribuir, revender o
        compartir el material con terceros.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-96">3. Resultados</h3>
      <p data-id="element-97">
        Los resultados pueden variar según el esfuerzo, dedicación y
        circunstancias individuales de cada usuario. No garantizamos ingresos
        específicos ni resultados financieros.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-98">4. Política de Reembolso</h3>
      <p data-id="element-99">
        Debido a la naturaleza digital del producto y el acceso inmediato al
        contenido, todas las ventas son finales. No se ofrecen reembolsos una
        vez completada la compra.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-100">5. Propiedad Intelectual</h3>
      <p data-id="element-101">
        Todo el contenido de InstaPrint AI, incluyendo textos, imágenes, diseños
        y metodologías, está protegido por derechos de autor. Queda prohibida su
        reproducción total o parcial sin autorización expresa.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-102">6. Modificaciones</h3>
      <p data-id="element-103">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios entrarán en vigor desde su publicación en el sitio
        web.
      </p>

      <h3 className="text-darkText font-bold mt-4" data-id="element-104">7. Ley Aplicable</h3>
      <p data-id="element-105">
        Estos términos se rigen por las leyes aplicables en la jurisdicción
        donde opera InstaPrint AI.
      </p>
    </>;
}